import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Design = () => {
    return (
        <div className="pochtabank-design">
            <FullWrapper caseName="pochtabank-designCase">
                <div className="pochtabank-designTitle">Новый дизайн сайта</div>
                <div className="pochtabank-designMiddle">
                    Дизайн-систему новой версии сайта сделала команда агентства{' '}
                    <a
                        href="https://www.dalee.ru/"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                    >
                        ДАЛЕЕ.
                    </a>
                    <br />
                    У&nbsp;коллег очень сильная UX-экспертиза в&nbsp;финтехе, и&nbsp;мы&nbsp;очень
                    им&nbsp;благодарны за&nbsp;профессиональное и&nbsp;творческое сотрудничество.
                    В&nbsp;процессе работы над проектом мы&nbsp;вместе разработали десятки макетов
                    и&nbsp;решили много нестандартных интерфейсных задач.
                </div>
                <div className="pochtabank-designBottom">
                    <div className="pochtabank-designDescription">
                        pochtabank.ru. Страница &laquo;Кредит наличными&raquo;
                    </div>
                    <div className="pochtabank-designImages">
                        <div className="pochtabank-designLeft">
                            <img
                                src="/images/pic/new-pochtabank/design-banner.jpg"
                                className="pochtabank-designBanner"
                                alt="design"
                            />
                        </div>
                        <div className="pochtabank-designRight">
                            <div className="pochtabank-designInner">
                                <img
                                    src="/images/pic/new-pochtabank/design-1.jpg"
                                    className="pochtabank-designImage"
                                    alt="design"
                                />
                            </div>
                            <div className="pochtabank-designInner">
                                <img
                                    src="/images/pic/new-pochtabank/design-2.jpg"
                                    className="pochtabank-designImage"
                                    alt="design"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Design;
